import { makeStyles } from '@material-ui/styles';
import tinycolor from 'tinycolor2';

export default makeStyles((theme) => ({
    layoutContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        padding: theme.spacing(4),
        border: '1px dashed',
        borderColor: theme.palette.primary.main,
        borderRadius: theme.spacing(1),
        backgroundColor: tinycolor(theme.palette.primary.main).setAlpha(0.05).toString(),
        position: 'relative',
        minHeight: 300,
    },
    layoutText: {
        color: theme.palette.primary.main,
        textAlign: 'center',
    },
    progressCentered: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    fullscreenContainer: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999,
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
    },
    fullscreenHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    fullscreenIframeWrapper: {
        flex: 1,
        width: '100%',
        overflow: 'hidden',
    },
    fullscreenIframe: {
        width: '100%',
        height: '100%',
        border: 'none',
        display: 'block',
    },
}));
